import axios from "axios";
import { firebaseInstance, tokenInstance } from "./api";
import config from "@config/config";

export const createSession = async (orderID, amount, currency) => {
  try {
    const response = await firebaseInstance.post(
      "/areeba/create-session",
      {
        orderID,
        amount,
        currency,
      },
      { headers: { UseBasicAuth: true } }
    );

    return response;
  } catch (error) {
    console.error(
      "createSession: an error occurred while calling firebaseInstance.post",
      error
    );
    throw error;
  }
};

export const createPreReceipt = async (
  orderID,
  cardID,
  successIndicator,
  holders,
  eventID,
  orgID,
  paidAmount,
  currency,
  paymentType,
  entryType,
  gateway,
  eventEntryID,
  label,
  waveID,
  quantity,
  usedDiscountCode,
  paidBy,
  linkID,
  source,
  bookingSessionID
) => {
  try {
    const response = await firebaseInstance.post(
      `areeba/create-pre-receipt`,
      {
        orderID,
        cardID,
        successIndicator,
        holders,
        eventID,
        orgID,
        paidAmount,
        currency,
        paymentType,
        entryType,
        gateway,
        eventEntryID,
        label,
        waveID,
        quantity,
        usedDiscountCode,
        paidBy,
        linkID,
        source,
        bookingSessionID,
      },
      { headers: { UseBasicAuth: true } }
    );

    return response;
  } catch (error) {
    console.error(
      "createPreReceipt: an error occurred while calling firebaseInstance.post",
      error
    );
    throw error;
  }
};

export const CreatePaymentSession = async (
  uid,
  email,
  entryID,
  eventID,
  waveID,
  quantity,
  gateway,
  seats,
  areas,
  seatingMapID,
  source,
  eventPromoterUrlID,
  orgID  // Pass the organizer ID if available
) => {
  try {
    const response = await firebaseInstance.post(`app/create-payment-session`, {
      uid,
      email,
      entryID,
      eventID,
      waveID,
      quantity,
      gateway,
      seats,
      areas,
      seatingMapID,
      source,
      eventPromoterUrlID
    });
    
    // Optionally, trigger a conversion event (e.g., "InitiateCheckout" or "Purchase")
    // Ensure you import and call sendMetaConversionEvent similarly.
    sendMetaConversionEvent(orgID, 'InitiateCheckout', { email }, { eventID, quantity })
      .catch(err => console.error("Meta conversion event failed", err));
    
    return response;
  } catch (error) {
    console.error(
      "CreatePaymentSession: an error occurred while calling firebaseInstance.post",
      error
    );
    throw error;
  }
};

export const createCashOrder = async (
  eventID,
  eventEntryID,
  entryType,
  waveID,
  email,
  phoneNumber,
  firstName,
  lastName,
  amount,
  currency,
  quantity,
  holders,
  gender,
  dob,
  country,
  source,
  linkID
) => {
  try {
    const response = await firebaseInstance.post("app/create-cash-order", {
      eventID,
      eventEntryID,
      entryType,
      waveID,
      email,
      phoneNumber,
      firstName,
      lastName,
      amount,
      currency,
      quantity,
      holders,
      gender,
      dob,
      country,
      source,
      linkID,
    });

    return response;
  } catch (error) {
    console.error(
      "An error occurred while creating cash order through firebaseInstance.post",
      error
    );
    throw error;
  }
};

export const getCurrencyConversion = async () => {
  try {
    const response = await firebaseInstance.get(`app/get-currency-conversion`);

    return response;
  } catch (error) {
    console.error(
      "getCurrencyConversion: an error occurred while calling firebaseInstance.get",
      error
    );
    throw error;
  }
};
//a
export const createPaymentIntentOnBeHalfOf = async ({
  orgID,
  eventID,
  entryType,
  label,
  quantity,
  totalAmount,
  currency,
  buyerEmail,
  paymentMethodID,
  totalRawAmount,
  gateway,
}) => {
  try {
    const { data } = await firebaseInstance.post(
      "stripe/create-payment-intent",
      {
        orgID,
        eventID,
        entryType,
        label,
        quantity,
        totalAmount,
        currency,
        buyerEmail,
        paymentMethodID,
        totalRawAmount,
        gateway,
      },
      { headers: { UseBasicAuth: true } }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const createGuestlistRequest = async (
  listID,
  eventID,
  primaryGuest,
  expectedGuests,
  socialLinks,
  promoter
) => {
  try {
    const { data } = await firebaseInstance.post(
      "app/create-guestlist-request",
      {
        listID,
        eventID,
        primaryGuest,
        expectedGuests,
        socialLinks,
        promoter
      },
      { headers: { UseBasicAuth: true } }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const createGuestlistPayment = async (
  eventID,
  eventEntryID,
  paymentType,
  reservationPaymentType,
  type,
  primaryGuest,
  expectedGuests,
  socialLinks,
  source,
  whishRedirectUrl,
  paymobRedirectUrl,
  networkRedirectUrl,
  networkCancelUrl,
  userNote,
  whatsappPhoneNumber,
  referral,
  eventPromoterUrlID
) => {
  try {
    const { data } = await firebaseInstance.post(
      "app/create-guestlist-payment",
      {
        eventID,
        eventEntryID,
        paymentType,
        reservationPaymentType,
        type,
        primaryGuest,
        expectedGuests,
        socialLinks,
        source,
        whishRedirectUrl,
        paymobRedirectUrl,
        networkRedirectUrl,
        networkCancelUrl,
        userNote,
        whatsappPhoneNumber,
        referral,
        eventPromoterUrlID
      },
      { headers: { UseBasicAuth: true } }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getLink = async (orgID, accountID, refreshUrl, returnUrl) =>
  await firebaseInstance.post(`stripe/create-account-link`, {
    orgID,
    accountID,
    refreshUrl,
    returnUrl,
  });

export const onboardingComplete = async (orgID, accountID) =>
  await firebaseInstance.post(`stripe/onboarding-complete`, {
    orgID,
    accountID,
  });

export const whishPaymentInit = async (req) => {
  console.log("jhgbh");
  const username = config.WHISH_API_AUTH_USERNAME;
  const password = config.WHISH_API_AUTH_PASSWORD;
  const requestData = req;

  try {
    const response = await firebaseInstance.post(
      "whish/api/payment-session-seating",
      requestData,
      {
        auth: {
          username: username,
          password: password,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const sendMetaConversionEvent = async (organizerId, eventName, userData, customData) => {
  try {
    const response = await firebaseInstance.post('meta/conversion-event', {
      organizerId,
      eventName,
      userData,    // Ideally, sensitive fields should be hashed on the server side.
      customData,
    });
    return response;
  } catch (error) {
    console.error("Error sending meta conversion event", error);
    throw error;
  }
};
export const getOmtStatus = async (receiptID) => {
  try {
    const response = await firebaseInstance.get(`app/payment/omt-pay-status?order_id=${receiptID}`);
    return response;
  } catch (error) {
    console.error("Error", error);
    throw error;
  }
};